export const useGlobalStore = defineStore('global-context', () => {
  const isLoading = ref(false)
  const isFullPageLoadingShown = ref(false)

  const rootDynamicComponent = shallowRef(null)
  const shouldRootDynamicComponentShow = ref(false)
  const rootDynamicComponentOption = ref({})

  const latitude = ref<number | null>(null)
  const longitude = ref<number | null>(null)

  const isLocationAcquired = computed(() => Number.isFinite(latitude.value) && Number.isFinite(longitude.value))
  const geolocation = computed<{ lat?: number; lng?: number }>(() =>
    isLocationAcquired.value ? { lat: latitude.value as number, lng: longitude.value as number } : {}
  )

  async function executeWithLoading<T>(fn: () => Promise<T>) {
    isLoading.value = true
    try {
      return await fn()
    } finally {
      isLoading.value = false
    }
  }

  function setShouldRootDynamicComponentShow(bool: boolean) {
    shouldRootDynamicComponentShow.value = !!bool
  }
  function setRootDynamicComponent(component: any) {
    rootDynamicComponent.value = component
  }
  function setRootDynamicComponentOption(option: any) {
    rootDynamicComponentOption.value = option || {}
  }
  function setUserCoords({ lat, lng }: { lat: number; lng: number }) {
    latitude.value = lat
    longitude.value = lng
  }

  return {
    isLoading,
    executeWithLoading,
    isFullPageLoadingShown,
    rootDynamicComponent,
    shouldRootDynamicComponentShow,
    rootDynamicComponentOption,
    latitude,
    longitude,
    isLocationAcquired,
    geolocation,
    setShouldRootDynamicComponentShow,
    setRootDynamicComponent,
    setRootDynamicComponentOption,
    setUserCoords,
  }
})
